import { TR, TD } from '../InsightTemplate/InsightTemplateElements';
import Logo from 'assets/general/Logo_BMI_Geo_Risk_Signals_Colour_nonend.svg?react';

const FONT_SIZE = 16;
const HEADER_BASE_FONT_SIZE = FONT_SIZE * 0.8;

type Props = {
    title: string;
    country: string;
    tag: string;
};

const PredictionTemplatePdfHeader = ({ title, country, tag }: Props) => {
    return (
        <TR>
            <TD style={{ padding: 0 }}>
                <div style={{ fontFamily: 'OpenSans' }}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '25px',
                        }}>
                        <Logo style={{ height: 38 }} />
                    </div>
                    <div
                        style={{
                            fontSize: FONT_SIZE,
                            fontWeight: 600,
                            lineHeight: 1.67,
                            color: '#000',
                            marginBottom: '12px',
                        }}>
                        {title}
                    </div>
                    <div
                        style={{
                            borderTop: '1px solid #000',
                            borderBottom: '1px solid #000',
                            marginBottom: '25px',
                            padding: '10px 0',
                            fontSize: HEADER_BASE_FONT_SIZE,
                            color: 'rgba(0, 0, 0, 0.65)',
                        }}>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '10px',
                            }}>
                            <i
                                className="gqi-tags"
                                style={{
                                    marginRight: '10px',
                                    fontSize: HEADER_BASE_FONT_SIZE,
                                }}
                            />

                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>
                                {country} - {tag}
                            </div>
                        </div>
                    </div>
                </div>
            </TD>
        </TR>
    );
};

export default PredictionTemplatePdfHeader;
